const en = {
  growth: 'Growth',
  myCurioso: 'My Curioso',
  augmentationSections: {
    head: 'Customize Head',
    body: 'Customize Body',
    back: 'Customize Back',
    legs: 'Customize Legs',
    tail: 'Customize Tail',
    eyes: 'Customize Eyes',
    face: 'Customize Face',
  },
  selectCostume: 'Select this costume for your curioso: Costume',
  augmentations: {
    head: {
      title: 'Head',
      costumes: {
        default: 'Classic Hair',
        crown: 'crown',
        unicorn: 'unicorn',
        horns: 'horns',
        antlers: 'antlers',
        partyhat: 'party hat',
        winterhat: 'winter hat',
        acorn: 'acorn',
        flower: 'flower',
        aviatorhat: 'aviator hat',
      },
    },
    body: {
      title: 'Body',
      costumes: {
        default: 'classic stripes',
        lacecollar: 'lace collar',
        quilted: 'quilted',
        bolt: 'bolt',
        scarf: 'scarf',
        collar: 'collar',
      },
    },
    back: {
      title: 'Back',
      costumes: {
        flower: 'flower',
        wings: 'wings',
        bat: 'bat',
        spikes: 'spikes',
        firespikes: 'fire spikes',
        starryback: 'starry back',
        cloak: 'cloak',
      },
    },
    legs: {
      title: 'Legs',
      costumes: {
        default: 'classic legs',
        duckfeet: 'duck feet',
        starry: 'starry',
        rainboots: 'rain boots',
        mercuryboots: 'mercury boots',
        ghost: 'ghost',
        redshoes: 'red shoes',
        flower: 'flower',
        fire: 'fire',
        octopus: 'octopus',
        spider: 'spider',
      },
    },
    tail: {
      title: 'Tail',
      costumes: {
        default: 'classic tail',
        squirrel: 'squirrel',
        spikey: 'spikey',
        winter: 'winter',
        starry: 'starry',
        dragon: 'dragon',
        fish: 'fish',
      },
    },
    eyes: {
      title: 'Eyes',
      costumes: {
        default: 'classic eyes',
        mask: 'mask',
        glasses: 'glasses',
        eyebrows: 'eyebrows',
        aviatorgoggles: 'aviator goggles',
        starryeyes: 'starry eyes',
        redcheeks: 'red cheeks',
        reptile: 'reptile',
        paint: 'paint',
        leaf: 'leaf',
        sunglasses: 'sunglasses',
      },
    },
    face: {
      title: 'Face',
      costumes: {
        fangs: 'fangs',
        mustache: 'mustache',
        tusks: 'tusks',
        goatbeard: 'goat beard',
      },
    },
  },
};

const spaEsDefault = {
  growth: 'Aumento',
  myCurioso: 'Mi Curioso',
  augmentationSections: {
    head: 'Personalizar Cabeza',
    body: 'Personalizar Cuerpo',
    back: 'Personalizar Espalda',
    legs: 'Personalizar Piernas',
    tail: 'Personalizar Cola',
    eyes: 'Personalizar Ojos',
    face: 'Personalizar Rostro',
  },
  selectCostume: 'Selecciona este disfraz para tu curioso: disfraz',
  augmentations: {
    head: {
      title: 'Cabeza',
      costumes: {
        default: 'por defecto',
        crown: 'corona',
        unicorn: 'unicornio',
        horns: 'cuernos',
        antlers: 'cornamenta',
        partyhat: 'sombrero de fiesta',
        winterhat: 'sombrero de invierno',
        acorn: 'bellota',
        flower: 'flor',
        aviatorhat: 'sombrero de aviador',
      },
    },
    body: {
      title: 'Cuerpo',
      costumes: {
        default: 'por defecto',
        lacecollar: 'cuello de encaje',
        quilted: 'acolchado',
        bolt: 'tornillo',
        scarf: 'bufanda',
        collar: 'cuello',
      },
    },
    back: {
      title: 'Espalda',
      costumes: {
        flower: 'flor',
        wings: 'alas',
        bat: 'murciélago',
        spikes: 'Picos',
        firespikes: 'picos de fuego',
        starryback: 'espalda estrellada',
        cloak: 'capa',
      },
    },
    legs: {
      title: 'Piernas',
      costumes: {
        default: 'por defecto',
        duckfeet: 'patas de pato',
        starry: 'estrellado',
        rainboots: 'botas de lluvia',
        mercuryboots: 'botas de mercurio',
        ghost: 'fantasma',
        redshoes: 'zapatos rojos',
        flower: 'flor',
        fire: 'fuego',
        octopus: 'pulpo',
        spider: 'araña',
      },
    },
    tail: {
      title: 'Cola',
      costumes: {
        default: 'por defecto',
        squirrel: 'ardilla',
        spikey: 'puntiagudo',
        winter: 'invierno',
        starry: 'estrellado',
        dragon: 'continuar',
        fish: 'pez',
      },
    },
    eyes: {
      title: 'Ojos',
      costumes: {
        default: 'por defecto',
        mask: 'mascarilla',
        glasses: 'anteojos',
        eyebrows: 'Cejas',
        aviatorgoggles: 'gafas de aviador',
        starryeyes: 'ojos estrellados',
        redcheeks: 'mejillas rojas',
        reptile: 'reptil',
        paint: 'pintar',
        leaf: 'hoja',
        sunglasses: 'Gafas de sol',
      },
    },
    face: {
      title: 'Rostro',
      costumes: {
        fangs: 'colmillos',
        mustache: 'Bigote',
        tusks: 'colmillos',
        goatbeard: 'barba de cabra',
      },
    },
  },
};

export default {
  en,
  spaEsDefault,
};
